import { Link } from "react-router-dom"

export const SelectBuy = ({ flo, handleRemoveInvoice, handleChangeSelectBuy, handleOpenNewInvoice, invoicesList }) => {
    return (
        <>
            {flo?.info_invoice ?
                <div className="flex flex-col items-start">
                    <Link
                        className="p-mini-link"
                        to={`/gastos/compras/${flo?.info_invoice?.id}`}
                        target='_blank'
                        style={{ fontSize: '12px', textTransform: 'capitalize', color: 'red' }}
                    >
                        <div className="text-start">
                            <i className="bi bi-check-circle-fill"></i>
                            <span className='ms-1'>Gastado</span>
                        </div>
                        <div
                            className="text-start ms-3"
                            style={{ textTransform: 'uppercase', fontSize: '10px', color: 'gray' }}
                        >
                            <span>Nro. {flo?.info_invoice?.numero}</span><br />
                            <span>{flo?.info_invoice?.nro_doc_justificacion}</span>
                        </div>
                    </Link>
                    <Link
                        to=""
                        className="text-xs capitalize mt-2 hover:text-gray-500 hover:underline"
                        onClick={() => handleRemoveInvoice("egreso", flo)}
                    >
                        <i className="bi bi-x"></i>
                        Quitar gasto
                    </Link>
                </div>
                :
                <div className='d-flex flex-column justify-content-end align-items-end'>
                    <Link
                        to=""
                        onClick={() => handleOpenNewInvoice(flo, 'egreso')}
                        className="p-mini-link"
                        style={{ fontSize: '12px', textTransform: 'capitalize', color: 'red' }}
                    >
                        + Crear gasto
                    </Link>

                    {invoicesList.length > 0 ?
                        <select
                            className='mt-1'
                            style={{ cursor: 'pointer', width: '180px', textTransform: 'uppercase', fontSize: '11px' }}
                            onChange={(e) => handleChangeSelectBuy(e, flo)}
                        >
                            <option value=''>--seleccionar existente--</option>
                            {invoicesList.map(inv => (
                                <option
                                    key={inv.id}
                                    value={inv.id}
                                    className='p-2'
                                >
                                    {inv?.nro_doc_justificacion ?
                                        <span>Nro. {inv.numero}{' | '}{inv?.nro_doc_justificacion}{' | '}{inv.referencia}</span>
                                        :
                                        <span>Nro. {inv.numero}{' | '}{inv.referencia}</span>
                                    }
                                </option>
                            ))}
                        </select> : ''
                    }

                </div>
            }
        </>

    )
}

